import { useDeprecatedPropsWarning } from '@nerdwallet/deprecate';
export var useDeprecatedClassNameStylePropsWarning = function useDeprecatedClassNameStylePropsWarning(component, props) {
  useDeprecatedPropsWarning({
    component: component,
    deprecatedProps: [{
      deprecated: 'className',
      version: '2.0.0'
    }, {
      deprecated: 'style',
      version: '2.0.0'
    }],
    props: props
  });
};